import vm from '@/business/main'

import {getLongStrDate, getDiffMinutes, formatDate, getPreStrDate} from './dateUtil'
import trainHandle from '../views/Tr/trOrder/handle'
import trainChangeHandle from '../views/Tr/trChange/handle'
import {queryVipParameter} from './publicApi'

// 公共方法 - 业务
var Business = {}

/**
 * @desc 打开订单详情操作
 * @param {Object} order 订单详情信息
 * @param {String} type 页面类型  applyRefund||applyChange
 */
Business.toOrderDetail = (detail, type) => {
  // if (detail.orderType == '11004' && (type == 'applyChange' || type == 'applyRefund')) {
  // 	vm.$toast('国际机票暂不支持线上退改，请联系客服处理')
  // 	return
  // }
  let url = {
    '11001': '/tk/tkOrderDetail', // 11001 国内机票正常单
    '11002': '/tk/tkRefundDetail', // 11002 国内机票退票单
    '11003': '/tk/tkChangeDetail',// 11003 国内机票改签单
    '11004': '/tk/tkOrderDetail',  // 11004 国际机票正常单
    '11005': '/tk/tkRefundDetail',  // 11005 国际机票退票单
    '11006': '/tk/tkChangeDetail', // 11006 国际机票改签单
    '11009': `/tr/OrderDetail/${detail.id}`,  // 11009 火车票正常单
    '11010': `/tr/RefundDetail/${detail.id}`,  // 11010 火车票退票单
    '11011': `/tr/ChangeDetail/${detail.id}`, // 11011 火车票改签单
    '11007': `/ht/htOrder/htOrderDetail/${detail.id}/${detail.isShowGuarantee}`,  // 11007 酒店正常单
    '11008': `/ht/htOrder/htRefundDetail/${detail.id}`,  // 11008 酒店退单
    '11018': '/car/carOrderDetail', // 11018 用车
    'jsyc': `/car/carJsycDetail/${detail.id}`, // 11018 用车
    '11023': `/visa/OrderDetail/${detail.id}`,
    '11028': '/restRoom/order', //  休息室
    '11029': '/fastCheck/order', //  快速安检
    '11030': '/checkIn/order', //  优选值机
    '11031': '/guestPass/order', //  要客通
    '11099': `/tripDetail?ccsqdId=${detail.id}`, //  要客通

    applyRefund: {
      '11001': '/tk/tkRefundApply',//机票申请退票
      '11009': trainHandle.refund,
      '11011': trainChangeHandle.refund,
      '11007': `/ht/htOrder/htRefund/${detail.id}`, // 酒店退票
      '11004': '/tk/tkRefundApplygj',//国际机票申请退票
    },
    applyChange: {
      '11001': '/tk/tkChangeApply', //机票申请改签
      '11011': trainHandle.refund,
      '11009': trainHandle.change,
      '11004': '/tk/tkChangeApplygj' //国际机票申请改签

    }
  }

  let path = '/'

  if (type) {
    path = url[type][detail.orderType] // 获取 applyRefund||applyChange 路径
  } else {
    path = url[detail.orderType]

    if (
      detail.orderType === $dict.ORDER_TYPE.car && detail.productType === '8' &&
      ['0', '1', '2', '3', '4', '5'].indexOf(detail.orderStatus) > -1
    ) {
      path = url['jsyc']
    }
  }

  if (typeof path === 'string') {
    vm.$router.push({path: path, query: {'orderId': detail.id, GoBack: true}})
  } else if (typeof path === 'function') {
    path(detail)
  }

  // ccp: {
  //   normal: "11024",
  //   refund: "11025",
  // },
  // vipLounge: {
  //   normal: "11012",  // 11012 机场服务订单
  //   refund: "11020" // 11020 机场服务退单
  // },
  // transfer: "11013",  // 11013 接送机订单
  // park: "11014",  // 11014 代客泊车订单
  // bx: "11015",  // 11015 保险订单
  // balance: "11016", // 11016 结欠单
  // settle: "11017",  // 11017 结算单
  // checkIn: "11019", // 11019 代办值机订单
  // trGrad: "11021",  // 11021 火车票抢票单
  // other: "11097", // 11097 其他
  // alter: "11098", // 11098 变更单
  // vipCcsqd: "11099", // 11099 出差申请单
  // qtJpkpxxd: "20001", // 20001 机票客票信息单
  // qtDzd: "20002" // 20002 对账单
}

/**
 * @desc 订单取消
 * @param {Object} order 订单详情信息
 * @param {String} type 页面类型
 */
Business.toOrderCancel = async (order) => {
  let obj = {
    '11001': {
      url: 'tkOrder/cancelTkOrder',//机票正常单取消
      params: {
        orderId: order.id
      }
    },
    '11004': {
      url: 'tkOrder/cancelTkOrder',//国际机票正常单取消
      params: {
        orderId: order.id
      }
    },
    '11002': {
      url: 'tkOrder/refundCancel',//取消机票退票
      params: {
        refundOrderId: order.id
      }
    },
    '11003': {
      url: 'tkOrder/cancelChangeOrder',//取消机票改签订单
      params: {
        changeId: order.id
      }
    },
    '11018': {
      url: 'carOrder/cancelCarOrder',//取消用车订单接口
      params: {
        orderId: order.id,
        qxbh: order.value,
        qxyy: order.text,
        sfqx: '1'
      }
    },
    '11007': {
      url: 'htQuery/hotelOrderCancel', // 酒店正常单取消接口
      params: {
        orderFrom: '10505',
        orderId: order.id
      }
    },
    '11008': {
      url: 'htQuery/hotelRefundCancel', // 酒店正常单取消接口
      params: {
        hotelRefundId: order.id,
        orderFrom: '10506',
        version: order.version
      }
    },
    '11009': {
      url: 'trOrder/cancelOrder', // 火车票正常单取消接口
      params: {
        orderId: order.id
      }
    },
    '11010': {
      url: 'trOrder/cancelTrRefund', // 火车票退单取消接口
      params: {
        id: order.id
      }
    },
    '11011': {
      url: 'trOrder/cancelTrChangeOrder', // 火车票改签单取消接口
      params: {
        changeId: order.id
      }
    },
    '11023': {
      url: 'VisaOrder/Cancel', // 签证取消
      params: {
        orderId: order.id
      }
    },
    '11028': {
      url: 'airService/cancel', // 休息室取消
      params: {
        orderId: order.id,
        version: order.version,
        orderFrom: order.orderFrom
      }
    },
    '11029': {
      url: 'airService/cancel', // 快速安检取消
      params: {
        orderId: order.id,
        version: order.version,
        orderFrom: order.orderFrom
      }
    },
    '11030': {
      url: 'airService/cancel', // 优选值机取消
      params: {
        orderId: order.id,
        version: order.version,
        orderFrom: order.orderFrom
      }
    },
    '11031': {
      url: 'airService/cancel', // 要客通)取消
      params: {
        orderId: order.id,
        version: order.version,
        orderFrom: order.orderFrom
      }
    }
  }

  await vm.$dialog.confirm({
    title: vm.$t('C474', '提示'),
    message: '确认取消订单？',
  }).then(async () => {
    try {
      await vm.$api[obj[order.orderType].url](obj[order.orderType].params)
      return vm.$toast('已取消')
    } catch (res) {
      throw res
    }
  }).catch(() => {
  })
}


// 根据订单编号获取订单Id
Business.getOrderIdByOrderNo = async (opt = {}) => {
  try {
    if (!opt.orderNo) {
      throw 'Business.getOrderIdByOrderNo：请传入订单编号！'
    }

    let id = ''
    const res = await vm.$api['common/allOrderList']({
      'dateStart': '2000-01-01',
      'dateEnd': '2099-01-01',
      'dateType': 1,
      'findScope': 2,
      'findType': opt.findType || 1,
      'orderNo': opt.orderNo,
      'queryType': 2,
      'pageNum': 1,
      'count': 20
    })

    const cache = res.data || {}
    if (cache.list && cache.list.length) {
      id = cache.list[0].id
    }

    console.log('根据订单号查到的订单：', cache)

    if (!id) {
      throw `没有查找到 订单:${opt.orderNo}`
    }

    return id
  } catch (error) {
    throw error
  }
}

/**
 * 去审批详情
 * */
Business.toApproval = function (params) {
  vm.$router.push({
    path: '/approval/Detail',
    query: {id: params.orderId, workItemId: params.workItemId, orderType: params.orderType}
  })
}


/**
 * @desc 送审操作
 * @param {Object} order 各种单据类型的订单详情信息
 */
Business.ApprovalSend = function (order, callback) {
  var query = {
    orderId: order.changeId || order.refundId || order.id || order.orderId,
    orderNo: order.orderNo,
    orderType: order.orderType,
    againApp: order.againApp ? 1 : 0
  }

  if (order.isShowApproval == 2) {
    vm.$dialog.confirm({
      message: '请确认是否按原审批流程再次送审？'
    }).then(() => {
      var params = {
        orderId: order.id || order.orderId,
        orderType: order.orderType,
        spgzId: order.appId || order.spgzId,
        againApp: 1
      }
      vm.$api['approval/vipBpmSendAppNew'](params).then(() => {
        vm.$dialog.alert({message: '送审成功！'}).then(() => {
          callback && callback()
        })
      })
    })
  } else {
    vm.$router.push({path: '/approval/Send', query})
  }
}

/**
 * @desc 送审撤回操作
 * @param {Object} order 各种单据类型的订单详情信息
 */
Business.ApprovalRevert = async (order, callback) => {
  await vm.$dialog.confirm({
    title: vm.$t('C474', '提示'),
    message: '确认撤回审批吗？',
  }).then(async () => {
    try {
      await vm.$api['approval/vipBpmRevertAppNew']({
        orderId: order.changeId || order.refundId || order.id || order.orderId,
        orderType: order.orderType,
      })

      callback && callback()
      return vm.$toast('已撤回')
    } catch (res) {
      throw res
    }
  }).catch(() => {
  })
}

/**
 * @desc 火车票 离发车时间太近（25分钟），要给出的提示
 * @param {Object} detail 火车票详情信息
 * @param {String} desc 描述
 * @return {Number} 距离发车剩余时间
 */
Business.DetectorEnum = {
  'refund': {time: 0, desc: '您所选择的车次已发车无法线上提交退票，请到车站办理。'}, // 发车前0分钟可以改
  'change': {date: 0, hours: 24, desc: '您所选择的车次已经过了办理改签时间，不能进行改签办理。'}, // 过了发车时间，票面日期的date天后能改。date天后hours点前能改
}
Business.DetectorNearTime = async function (detail, type, desc) {
  var nowTime = getLongStrDate(),
    departTime = detail.nDepartTime,
    message = desc || Business.DetectorEnum[type].desc

  if (!departTime) departTime = detail.fromDate + ' ' + detail.fromTime

  let changeParams = await queryVipParameter('11603005')
  Business.DetectorEnum.change.date = changeParams.value1 || 0
  Business.DetectorEnum.change.hours = changeParams.value2 || 24

  // 是否过了发车时间
  var isPass = getDiffMinutes(nowTime, departTime) <= 0

  if (isPass) {
    if (Business.DetectorEnum[type].time !== undefined) {
      if (getDiffMinutes(nowTime, departTime) <= Business.DetectorEnum[type].time) {
        vm.$dialog({message})
        return false
      }
    } else if (Business.DetectorEnum[type].date !== undefined) {
      var departTimeDate = formatDate(departTime),
        canChangeTime = getPreStrDate(departTimeDate.date, Business.DetectorEnum[type].date) + ' ' + Business.DetectorEnum[type].hours + ':00:00'

      if (getDiffMinutes(nowTime, canChangeTime) <= 0) {
        vm.$dialog({message})
        return false
      }
    }
  }

  return true
}

/**
 * @desc 火车票 距发车时间48小时以内提交改签的，只能改签当日的车次，obt上要做控制
 * @param {Object} detail 火车票详情信息
 * @param {Boolean} isAlert 是否弹出业务描述提醒
 * @return {Number} 距离发车剩余时间
 */
Business.DetectorChangeTime = function (detail, isAlert) {
  var nowTime = getLongStrDate(),
    departTime = detail.nDepartTime

  if (!departTime) departTime = detail.fromDate + ' ' + detail.fromTime

  var diff = getDiffMinutes(nowTime, departTime)
  if (diff < 60 * 48) {
    if (isAlert) vm.$dialog({message: '在有运输能力的前提下，开车前48小时以内，可改签开车前的其他列车，也可改签开车后至票面日期当日24:00之间的其他列车，不办理票面日期次日及以后的改签；开车之后，旅客仍可改签当日其他列车。'})
    return false
  }
  return true
}

/**
 * @desc 火车退票 计算退票手续费，可能跟实际不一样。
 * 当前时间距离票面时间（小时）
 *    0 - 24         按票价 20% 计
 *    24- 48         按票价 10% 计
 *    48-(15 * 24)   按票价 5%  计
 * @param {Object} detail 火车票详情信息
 * @param {Object} psgList 所选退票人
 * @return {Number} 返回退票费
 */
Business.ComputedRefundAmount = function (detail, psgList) {
  if (psgList.length === 0) return 0

  var nowTime = getLongStrDate(),

    departTime = detail.departTime,
    price = 0
  console.log('nowTime:' + nowTime)

  psgList.forEach(psg => price += psg.ticketPrice)

  if (!departTime) departTime = detail.fromDate + ' ' + detail.fromTime

  console.log('departTime:' + departTime)
  var diff = getDiffMinutes(nowTime, departTime)

  console.log('diff:' + diff)

  console.log('before_price:' + price)

  if (diff < 60 * 24) {
    price *= .2
  } else if (diff < 60 * 24 * 2) {
    price *= .1
  } else if (diff < 60 * 24 * 8) {
    price *= .05
  } else {
    price = 0
  }

  console.log('after_price:' + price)

  /**
   * 根据退票手续费率计算的手续费以0.5元为单位，尾数
   * 小于 0.25元的舍去、
   *     0.25 - 0.75元的计为 0.5元、
   *     0.75元以上的进为1元。
   * 退票费最低按2元计收。
   */
  if (price != 0) {
    let decimals = (price % 1).toFixed(2) // 取余数并保留两位
    price = Math.floor(price) // 取整

    if (decimals < .25) {
      decimals = 0
    } else if (decimals < .75) {
      decimals = .5
    } else {
      decimals = 1
    }
    price += decimals
    return Math.max(2, price).toFixed(2)
  }
  console.log('end_price:' + price)
  return price

}

export default Business
